import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { InfoIcon } from '@yonderland/andes-icons';
import { Box, Icon, TextAlpha, Tooltip } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { I18N_NAMESPACES } from '../../../constants/i18nConstants';
import { makeGetSpecialtyType } from '../../../redux/product/selectors/ProductSelector';
export const ProductSpecialtyMessage = () => {
    const { t } = useTranslation(I18N_NAMESPACES.product);
    const specialtyType = useSelector(makeGetSpecialtyType());
    if (!specialtyType) {
        return null;
    }
    return (_jsx(Box, { testId: "product_specialty_message", padding: "4", backgroundColor: "informative-bg", borderRadius: "md", children: _jsxs(TextAlpha, { color: "informative", children: [t('product.specialty.message', {
                    specialty_type: t(`product.specialty.type.${specialtyType}`),
                }), ' ', _jsx(Tooltip, { text: t(`product.specialty.tooltip.${specialtyType}`), hasCloseBtn: false, children: _jsx(Icon, { size: "xs", source: InfoIcon }) })] }) }));
};
